import { createRouter, createWebHistory } from 'vue-router'

// Menu
import MenuView from '../views/menu/MenuView.vue'
import CategoryView from '../views/menu/CategoryView.vue'
import AllCategoriesView from '../views/menu/AllCategoriesView.vue'
import ProductView from '../views/product/ProductView.vue'

// Users
import LoginView from '../views/users/LoginView.vue'

// Checkout
import Recommendations from '../views/checkout/Recommendations.vue'
import ReviewBag from '../views/checkout/ReviewBag.vue'
import CheckoutView from '../views/checkout/CheckoutView.vue'
import ConfirmationView from '../views/checkout/OrderConfirmationView.vue'

// Other
import StepsView from '../views/wizard/StepsView.vue'

import NotFound from '../views/app/NotFound.vue'

const router = createRouter({
  history: createWebHistory('/catering/order/'),
  routes: [
    {
      path: '/wizard',
      name: 'wizard',
      alias: '/',
      component: StepsView
    },
    {
      path: '/wizard/:step/:redirect?',
      name: 'wizard-step',
      component: StepsView,
      beforeEnter: (to, from, next) => {
        // Make sure the user didn't try to edit the step from the step (most likely by clicking the bag dropdown)
        if (!to.params.redirect && from.name && to.name != from.name) {
          let redirectedPath = to.path!+'/r';
          next(({path: redirectedPath} as any));
        } else {
          next();
        }
      }
    },
    // --------------------------------------------------------------------------------
    //
    // Menu
    //
    // --------------------------------------------------------------------------------
    {
      path: '/menu',
      name: 'menu',
      component: MenuView
    },
    {
      path: '/menu/categories',
      name: 'all-categories',
      component: AllCategoriesView
    },
    {
      path: '/menu/category/:id',
      name: 'category',
      component: CategoryView
    },
    {
      path: '/menu/product/:id',
      name: 'product',
      component: ProductView
    },
    {
      path: '/menu/product/:id/:bpid',
      name: 'edit-product',
      component: ProductView
    },
    // --------------------------------------------------------------------------------
    //
    // Checkout
    //
    // --------------------------------------------------------------------------------
    {
      path: '/recommendations',
      name: 'recommendations',
      component: Recommendations
    },
    {
      path: '/review-bag',
      name: 'review-bag',
      component: ReviewBag
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: CheckoutView
    },
    {
      path: '/order-confirmation',
      name: 'order-confirmation',
      component: ConfirmationView
    },
    // --------------------------------------------------------------------------------
    //
    // User
    //
    // --------------------------------------------------------------------------------
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    // --------------------------------------------------------------------------------
    //
    // Global App
    //
    // --------------------------------------------------------------------------------
    {
      path: "/:notFound",
      component: NotFound,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    return { top: 0 }
  }
})

export default router
